import React from 'react'
import { Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { ColorChannelsIcon } from 'icons'
import useStyles from './ColoursButton.style'

const ColoursButton: React.FC = () => {
  const { classes } = useStyles()
  const location = useLocation()
  return (
    <Wrapper className={classes.deviceSettingsContainer}>
      <Link
        to={`${location.pathname}/colours`}
      >
        <Wrapper className={classes.deviceSettingsItem}>
          <Wrapper className={classes.deviceSettingsIcon}>
            <ColorChannelsIcon />
          </Wrapper>
          <Typography className={classes.deviceSettingsLabel}>Colours</Typography>
        </Wrapper>
      </Link>
    </Wrapper>
  )
}

export default ColoursButton
